module.exports = __webpack_public_path__ + "static/img/logo27.f7c8f2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo27.png
// module id = AhVW
// module chunks = 1